import PISet from "@/assets/js/pi-set"

export default class EditablePISet extends PISet {
  constructor() {
    super()
  }

  setInstruction(name, value) {
    this[name] = value;
  }

  clearInstructions() {
    for (const key of PISet.instructionKeys) {
      this[key] = 0;
    }
  }
}
